<div class="frontend-kit-example_tabbed-content">
  <div class="a-tab-navigation__wrapper">
    <ol class="a-tab-navigation" role="tablist">
      @for (tab of tabs; track tab; let i = $index) {
        <li
          class="a-tab-navigation__item"
          >
          <button
            type="button"
            class="a-tab-navigation__tab"
            [ngClass]="{'-selected': selectedTabIndex === i}"
            [attr.data-frok-tab-identifier]="tab.contentId"
            tabindex="0"
            role="tab"
            [attr.aria-controls]="'tab-' + tab.contentId"
            [attr.id]="'tab-' + tab.contentId"
            [attr.aria-selected]="selectedTabIndex === i"
            (click)="selectTab(i)"
            >
            <span class="a-tab-navigation__tab-content">
              <span class="a-tab-navigation__label">
                {{ tab.label | translate }}
              </span>
            </span>
          </button>
        </li>
      }
    </ol>
  </div>

  @for (tab of tabs; track tab; let i = $index) {
    <div
      class="frontend-kit-example_content"
      [style.display]="selectedTabIndex === i ? 'block' : 'none'"
      [attr.data-frok-content-identifier]="tab.contentId"
      [attr.id]="'panel-' + (i + 1)"
      [attr.aria-labelledby]="'panel-' + (i + 1)"
      role="tabpanel"
      [hidden]="selectedTabIndex !== i"
      >
      @if (tab.component === 'incident') {
        <app-incident-overview [reloadFlag]="reloadFlag"></app-incident-overview>
      }
      @if (tab.component === 'asset') {
        <app-asset-sync></app-asset-sync>
      }
    </div>
  }
</div>
